import {gql} from '@apollo/client';
import {FEE_PROFILE_FRAGMENT} from '../../graphql/feeProfileFragment';

export const BUILDER_POT = gql`
  ${FEE_PROFILE_FRAGMENT}
  fragment BuilderPotDetails on PotType {
    id
    curoId
    name
    isDeleted
    full
    isCash
    productIsBank
    bankDetails
    currentDirectValue
    valuationMethod
    proposalReference
    feeProfiles {
      ...FeeProfileFragment
    }
    productName {
      id
      formattedName
      acronym
      reportName
    }
    isValidated
    policyHolder
    originalOvrId
    isDataGather
    isAuthorityHeld
    productProvider {
      id
      curoId
      name
      providerType
      isFavourite
      isPanel
      formattedName
      isBank
      reportName
      isSaltus
      showMandateSelector
    }
    totalValue
    isSaltus
    review {
      id
      isSpp
      isSppDa
      isSppAr
      isSppRi
    }
    usedValue
    parent {
      id
    }
    planNumber
    planStatus
    withdrawalReason
    sortCode
    isAuthorised
    nominatedAccount {
      id
      name
    }
    contact {
      id
      simplifiedName
    }
    isDummy
    modelPortfolio {
      id
      name
      providerContact {
        id
        name
        lastName
        jobTitle
      }
    }
    servicingRights
    inSpecie
    isShellPlan
    mandate
    inTrust
    crystallisedFunds
    uncrystallisedFunds
    notes
  }
  fragment BuilderPot on PotType {
    ...BuilderPotDetails
    dentistChildren {
      ...BuilderPotDetails
    }
  }
`;

// Withdrawal destinations are BankAccount entities (not pots) since DBO-1436.
export const BUILDER_BANK_ACCOUNT = gql`
  fragment BuilderBankAccount on BankAccountType {
    id
    curoId
    name
    accountName
    accountNumber
    sortCode
    status
    # Aliased: PotType.isValidated is nullable and shares the potBankUnion
    # union with BankAccountType, so identical names would fail field merging
    # if both members were ever selected together.
    isAccountValidated: isValidated
    provider {
      id
      name
      formattedName
    }
    contact {
      id
      simplifiedName
    }
  }
`;

// A contribution funded from new money (the dummy cash pot) rather than from
// an existing plan or a bank account.
export const BUILDER_CASH_POT = gql`
  fragment BuilderCashPot on CashPotType {
    id
    # Aliased: PotType.isCash is nullable and shares the ContributeSourceType
    # union with CashPotType, so identical names would fail field merging when
    # both members are selected together.
    isCashPot: isCash
  }
`;
